import {Component, OnDestroy, OnInit} from '@angular/core';
import {Layer, LayerLoadType} from '../types';
import {LayerService} from '../../../services/layer.service';
import {of} from 'rxjs';
import { PlanLayer } from '../layers/default/picto.layer';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'layer-control',
  templateUrl: './layer-control.component.html',
  standalone: false
})
export class LayerControlComponent implements OnInit, OnDestroy {

  collapsed = false;

  constructor(
    private layerService: LayerService,
    private snackbar: MatSnackBar,
  ) {}

  layers = [];
  subscription: any;

  protected readonly LayerLoadType = LayerLoadType;

  public handleLayerVisibility(layer: Layer): void {
    layer.setActive(!layer.active);

    this.layerService.requestRender();
  }

  ngOnInit(): void {
    this.subscription = this.layerService.layers$.subscribe(layers => {
      this.layers = layers;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public updateIconSize(layer: PlanLayer, size: number): void {
    if (size < 10 || size > 60) {
      this.snackbar.open('La taille de l\'icône doit être comprise entre 10 et 60.', 'Fermer', {
        duration: 3000,
      });
      return;
    }

    if ('updateIconSize' in layer) {
      layer.updateIconSize(size);
    }
  }
}
